<template>
    <div class="radio">
      <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
      <div class="component-content">
        <el-radio-group v-model="value" class="radio-group" :style="{'height':height}">
          <el-radio v-for="(option, index) in options" :key="index" :label="option.value" disabled></el-radio>
        </el-radio-group>
      </div>
    </div>
</template>

<script>
import { componentMixin, dataSourceMixin } from '../mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
export default {
  name: 'rc-radio',
  props: ['initComponent'],
  mixins: [ componentMixin, heightMixin, dataSourceMixin ],
  data () {
    return {
      value: '',
      options: [],
      component: this.initComponent
    }
  },
  mounted () {
    if (this.initComponent.properties.template && this.initComponent.properties.template.enable) {
      this.loadTemplateOptions()
    } else if (this.initComponent.properties.dataSource && this.initComponent.properties.dataSource.enable) {
      this.loadDataSourceOptions()
    }
  },
  watch: {
    'initComponent.properties.template.stringOptions' () {
      this.loadTemplateOptions()
    },
    'initComponent.properties.dataSource': {
      handler (value) {
        value.reportId && this.loadDataSourceOptions()
      },
      deep: true

    }
  }
}
</script>

<style lang="scss">
.radio {
    height: calc(100% - 50px);
   .radio-group{
    overflow-y: hidden;
    width: 100%;
    height: 100%;
    label.el-radio {
      display: block;
      margin-left: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 28px;
      line-height: 28px;
    }
 }
}

</style>



// WEBPACK FOOTER //
// src/components/form/components/radio/rc-radio.vue